let urlUtil;
import { PATH } from '../constants/app';
const RESIZED_IMAGE_DEFAULT_SIZE = 100;
const DEFAULT_PRODUCT_IMAGE =
  'https://dzt1km7tv28ex.cloudfront.net/static/shop/product_no_image.png';

export default urlUtil = {
  // 画像オブジェクト or パスからリサイズ後の画像URLを返す
  //
  // resizedImageUrl({imgObj})
  // resizedImageUrl({imgObj}, 360, 240, { type: 'crop' })
  // resizedImageUrl('/shop/sku/xxx.jpg', 120)
  //
  // @param doc {Object or String} 画像オブジェクト or 画像パス
  // @param width {Number} 画像幅 指定されなかった場合は画像オブジェクトのオリジナルサイズまたはデフォルト値
  // @param height {Number} 画像高さ 指定されなかった場合は幅を代入し、正方形サイズにする
  // @param options {Object} リサイズタイプを指定
  //
  resizedImageUrl(doc, width, height, options = {}) {
    let src;
    const type = options.type || 'ex';

    if (!doc) {
      return DEFAULT_PRODUCT_IMAGE;
    }

    if (typeof doc === 'string') {
      src = doc;
    } else {
      src = doc.source;
      if (!width) {
        width = doc.width;
        if (doc.images && doc.images.o && doc.images.o.width) {
          width = doc.images.o.width;
        }
      }
      if (!height) {
        height = doc.height;
        if (doc.images && doc.images.o && doc.images.o.height) {
          height = doc.images.o.height;
        }
      }
    }

    // 画像のクロッピングが指定されていたら処理
    if (doc.images && doc.images.i && doc.images.i.coordinates) {
      let c;
      try {
        c = JSON.parse(doc.images.i.coordinates);
      } catch (error) {
        c = {
          x: 0,
          y: 0,
          w: 300,
          h: 300,
          width: 300,
          height: 300
        };
      }
      // パースできない場合デフォルト値
      return `${PATH.RESIZE}${type}/${width}.${width}/${c.x}.${c.y}.${c.w}.${c.h}${src}`;
    }

    switch (type) {
      case 'full':
      case 'bypass':
        return `${PATH.RESIZE}${type}${src}`;
      case 'width':
        return `${PATH.RESIZE}${type}/${width}${src}`;
      default:
        if (!width) {
          width = RESIZED_IMAGE_DEFAULT_SIZE;
        }
        if (!height) {
          height = width;
        }

        return `${PATH.RESIZE}${type}/${width}.${height}${src}`;
    }
  },

  // Cloud front にアップロードされた静的画像の URL を取得する
  //
  // @param src {String} 画像パス
  // @param notConvertWebP {Boolean} WebP に変換しない場合に true を指定する
  cloudImageUrl(src, notConvertWebP = false) {
    src = urlUtil.resizedImageUrl(src, null, null, {
      type: notConvertWebP ? 'full' : 'bypass'
    });
    if (!notConvertWebP) {
      src = urlUtil.webp(src);
    }
    return src;
  },

  // /public/ に格納された静的画像の URL を取得する
  //
  // @param src {String} 画像パス
  staticImageUrl(src) {
    return `${PATH.STATIC}${src}`;
  },

  // WebP に変換されたURLを返す
  // @param src {String} 画像パス
  webp(src) {
    if (!src) {
      return src;
    }
    if (window.tom && window.tom.helper && window.tom.helper.filterImageSrc) {
      return window.tom.helper.filterImageSrc(src);
    }
    return src;
  }
};

// import { webp } from '../util/url'; のような記述の場合 default が参照されない場合があるため named export も併記
export const resizedImageUrl = urlUtil.resizedImageUrl;
export const cloudImageUrl = urlUtil.cloudImageUrl;
export const staticImageUrl = urlUtil.staticImageUrl;
export const webp = urlUtil.webp;
